import { ReactComponent as Logo } from './Logo_plain.svg'

export default Logo
